import { AppState } from "../../reducers";
import { LanguagesState } from "./languagesSlice";

export const languagesSelector = (state: AppState): LanguagesState => {
  return state.languages;
};
